import type { DataGridRef } from 'devextreme-react/data-grid';
import type { ReactNode, RefObject } from 'react';
import { OpsGridToolbarItems, type OpsGridToolbarMenuItem } from '../opsDataGrid/OpsGridToolbar';

export interface PatientTrackingGridToolbarItemsProps {
  gridRef: RefObject<DataGridRef | null>;
  loading?: boolean;
  onRefresh: () => void;
  newItem?: { hint: string; onClick: () => void };
  editItem?: { hint: string; active: boolean; onClick: () => void };
  /** Upload toolbar item from usePatientTrackingCsvImport (render popup outside the grid). */
  uploadSlot?: ReactNode;
  uploadMenuItem?: OpsGridToolbarMenuItem | null;
  export: { fileName: string; worksheetName: string; hint?: string };
}

export function PatientTrackingGridToolbarItems({
  gridRef,
  loading,
  onRefresh,
  newItem,
  editItem,
  uploadSlot,
  uploadMenuItem,
  export: exportConfig
}: PatientTrackingGridToolbarItemsProps) {
  return (
    <OpsGridToolbarItems
      gridRef={gridRef}
      loading={loading}
      onRefresh={onRefresh}
      newItem={newItem}
      editItem={editItem}
      uploadSlot={uploadSlot}
      uploadMenuItem={uploadMenuItem ?? undefined}
      export={{
        fileName: exportConfig.fileName,
        worksheetName: exportConfig.worksheetName,
        hint: exportConfig.hint
      }}
    />
  );
}
